<!--
  ============================================================================
  MadriLocalLandingV2 — Versão para TRÁFEGO FRÍO.
  ============================================================================
  Reutiliza a estrutura visual da OligoscanLanding (alerta topo + hero com
  2 caminhos + seção explicativa com antes/depois + features + tech-box de
  espectrofotometría + FAQ + formulário), mas adaptada para o ângulo de
  "demostración exclusiva presencial en Madrid" — sem o ângulo de
  rebranding (público frío não conhece nem OligoScan nem OligoCheck).

  Diretrizes de copy aplicadas:
    • Tom institucional. Sujeito = "OligoCheck" / "el especialista" /
      "nuestro equipo técnico", nunca "yo".
    • Escassez tratada como agenda corporativa: datas específicas,
      franjas reduzidas, asignación por orden de solicitud.
    • Credenciales (+10 años, +12.000 profesionales, 3 continentes,
      espectrofotometría validada) reforçadas em pontos múltiplos.
    • Sem comparações com análise de sangue / extração sanguínea —
      são análises diferentes; o equipamento é descrito pelo que FAZ.

  Configurações:
    • Idioma único: ES (sem LangSwitcher, sem auto-idioma).
    • No indexable: bloqueada em robots.txt (/madri-local-v2).
    • Redirect pós-form: reaproveita /oligocheck/gracias.
    • ActiveCampaign: IDs TODO (substituir quando o form for criado).
  ============================================================================
-->
<template>
  <AppShell
    v-model:current-lang="currentLang"
    variante="produto"
    :mostrar-switcher="false"
    :auto-idioma="false"
  >
    <!-- ============================================================
         ALERTA TOPO — escassez institucional (não promocional)
         ============================================================ -->
    <template #alerta>
      <AlertaTopo destaque="AGENDA EN MADRID:">
        franjas reducidas durante la visita del especialista. Asignación por orden de solicitud.
      </AlertaTopo>
    </template>

    <!-- ============================================================
         1. HERO — Demonstração exclusiva en Madrid
         ============================================================ -->
    <PageHero
      :logo-src="logoBranco"
      logo-alt="OligoCheck"
      badge="Presentación exclusiva · Madrid"
      badge-variante="azul"
      subtitulo="Nuestro equipo técnico se desplazará a Madrid durante una agenda limitada para realizar demostraciones privadas en consultas profesionales — sin coste y sin compromiso de compra."
    >
      <template #titulo>
        <span class="titulo-pre">Demostración técnica privada en</span>
        <span class="ds-texto-gradiente">su consulta de Madrid</span>
      </template>

      <template #ctas>
        <p class="caminhos-pergunta">¿Cómo prefiere avanzar?</p>

        <div class="caminhos-grid">
          <!-- CAMINHO A: RESERVAR FRANJA (form) -->
          <a
            href="#formulario-compra"
            @click.prevent="scrollToForm"
            class="caminho-card caminho-compra"
          >
            <div class="caminho-icone">
              <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                <line x1="16" y1="2" x2="16" y2="6"/>
                <line x1="8" y1="2" x2="8" y2="6"/>
                <line x1="3" y1="10" x2="21" y2="10"/>
              </svg>
            </div>
            <div class="caminho-conteudo">
              <span class="caminho-label">RESERVAR FRANJA</span>
              <strong class="caminho-titulo">Solicitar demostración</strong>
              <span class="caminho-desc">Complete sus datos y nuestro equipo coordinará la visita en menos de 24 h.</span>
            </div>
            <div class="caminho-seta">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>
            </div>
          </a>

          <!-- CAMINHO B: CONSULTAR DISPONIBILIDADE (WhatsApp direto) -->
          <a
            :href="whatsappComercialUrl"
            target="_blank"
            rel="noopener"
            class="caminho-card caminho-suporte"
          >
            <div class="caminho-icone suporte-icone">
              <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="currentColor">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
              </svg>
            </div>
            <div class="caminho-conteudo">
              <span class="caminho-label">CONSULTAR DISPONIBILIDAD</span>
              <strong class="caminho-titulo">Hablar por WhatsApp</strong>
              <span class="caminho-desc">Contacto directo con el equipo comercial para verificar franjas libres.</span>
            </div>
            <div class="caminho-seta">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>
            </div>
          </a>
        </div>
      </template>

      <template #trust>
        <TrustBar :items="[
          { texto: '+10 años en el mercado europeo', icone: 'clock' },
          { texto: '+12.000 profesionales en 3 continentes', icone: 'users' },
          { texto: 'Tecnología espectrofotométrica validada', icone: 'shield' }
        ]" />
      </template>
    </PageHero>

    <!-- ============================================================
         2. ¿POR QUÉ ESTA VISITA? — substitui o bloco de "rebranding"
            da OligoscanLanding por contexto da agenda especial.
         ============================================================ -->
    <SecaoPadrao variante="alt">
      <div class="explicativa-grid">
        <div class="explicativa-texto">
          <BadgePill>¿Por qué esta visita?</BadgePill>
          <h2 class="ds-secao-titulo">
            Una agenda
            <span class="ds-texto-gradiente">limitada</span>
            del especialista en Madrid
          </h2>
          <p class="explicativa-desc">
            OligoCheck ha designado un especialista técnico para realizar
            demostraciones presenciales en consultas profesionales de Madrid
            durante una agenda concreta. Cada visita se realiza
            directamente en la consulta del profesional, con su equipo,
            sin desplazamientos ni compromiso de compra.
          </p>

          <!-- Antes/Depois — formato institucional adaptado -->
          <div class="antes-depois">
            <div class="ad-item ad-antes">
              <span class="ad-label">Modelo tradicional</span>
              <strong>Showroom</strong>
            </div>
            <div class="ad-seta">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>
            </div>
            <div class="ad-item ad-depois">
              <span class="ad-label">Esta visita</span>
              <strong class="ds-texto-gradiente">En su consulta</strong>
            </div>
          </div>

          <ul class="explicativa-lista">
            <li>
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
              <span>Demostración del equipo en el entorno real de su consulta</span>
            </li>
            <li>
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
              <span>Presentación abierta a su equipo profesional</span>
            </li>
            <li>
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
              <span>Lectura técnica real con un paciente o muestra propia</span>
            </li>
            <li>
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
              <span>Sesión de consultas técnicas con el especialista</span>
            </li>
          </ul>
        </div>

        <div class="explicativa-visual">
          <div class="visual-glow"></div>
          <img src="@/assets/images/hero-device.png" alt="Equipo OligoCheck" class="visual-img" />
        </div>
      </div>
    </SecaoPadrao>

    <!-- ============================================================
         3. ¿QUÉ ES OLIGOCHECK? — apresentação direta do produto
            (público frío não conhece a marca → bloco educativo).
         ============================================================ -->
    <SecaoPadrao>
      <SecaoHeader
        badge="Conozca la tecnología"
        titulo-antes="¿Qué es"
        titulo-destaque="OligoCheck?"
        subtitulo="Un equipo profesional de análisis mineral intracelular que evalúa más de 40 oligoelementos y metales pesados directamente desde la palma de la mano del paciente, en cuestión de segundos."
      />

      <div class="features-grid">
        <FeatureCard
          titulo="Resultados en segundos"
          descricao="Análisis completo en menos de 5 segundos, con el informe disponible en la propia consulta."
        >
          <template #icone>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>
          </template>
        </FeatureCard>

        <FeatureCard
          titulo="No invasivo · sin agujas"
          descricao="Lectura óptica sobre la palma de la mano. El paciente no necesita preparación previa."
        >
          <template #icone>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.24 12.24a6 6 0 0 0-8.49-8.49L5 10.5V19h8.5z"/><line x1="16" y1="8" x2="2" y2="22"/><line x1="17.5" y1="15" x2="9" y2="15"/></svg>
          </template>
        </FeatureCard>

        <FeatureCard
          titulo="Medición intracelular"
          descricao="Evalúa minerales, oligoelementos y metales pesados a nivel tisular, mediante interacción óptica directa."
        >
          <template #icone>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 12h-4l-3 9L9 3l-3 9H2"/></svg>
          </template>
        </FeatureCard>

        <FeatureCard
          titulo="Informe profesional"
          descricao="Más de 40 parámetros con visualización gráfica, listo para interpretar y entregar al paciente."
        >
          <template #icone>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>
          </template>
        </FeatureCard>
      </div>

      <!-- BLOCO TÉCNICO: ESPECTROFOTOMETRÍA -->
      <div class="tech-box">
        <div class="tech-box-grid">
          <div class="tech-box-icone">
            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M3 12h4l3-9 4 18 3-9h4"/>
            </svg>
          </div>
          <div class="tech-box-conteudo">
            <div class="tech-box-label">La tecnología por detrás</div>
            <h3 class="tech-box-titulo">Espectrofotometría de absorción adaptada a tejidos vivos</h3>
            <p class="tech-box-desc">
              OligoCheck utiliza una variante patentada de la espectrofotometría
              de absorción óptica, técnica de referencia en laboratorios clínicos
              para cuantificar minerales. La medición se realiza directamente
              sobre el tejido vivo de la palma de la mano, de forma totalmente
              no invasiva y con precisión de grado laboratorial.
            </p>
            <ul class="tech-box-lista">
              <li>
                <div class="tech-step-body">
                  <strong>Emisión multiespectro</strong>
                  <span>Un módulo óptico emite haces de luz en longitudes de onda específicas (desde el UV cercano hasta el infrarrojo) calibradas individualmente para cada oligoelemento y metal analizado.</span>
                </div>
              </li>
              <li>
                <div class="tech-step-body">
                  <strong>Análisis del patrón de absorción</strong>
                  <span>Cada mineral absorbe la luz en una longitud de onda única. Sensores de alta sensibilidad miden la luz reflejada y calculan la concentración intracelular correspondiente.</span>
                </div>
              </li>
              <li>
                <div class="tech-step-body">
                  <strong>Cálculo algorítmico</strong>
                  <span>Un algoritmo propietario cruza los datos espectrales con una base comparativa de más de 2 millones de mediciones clínicas, generando valores cuantitativos de más de 40 parámetros en menos de 5 segundos.</span>
                </div>
              </li>
            </ul>
            <p class="tech-box-nota">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>
              Método registrado, no invasivo, sin radiación ionizante y aprobado para uso profesional.
            </p>
          </div>
        </div>
      </div>
    </SecaoPadrao>

    <!-- ============================================================
         4. AGENDA / ESCASEZ INSTITUCIONAL
            Bloco dedicado a reforçar a escassez antes do FAQ/form.
            Visualmente representa a agenda do especialista.
         ============================================================ -->
    <SecaoPadrao id="agenda" variante="default">
      <SecaoHeader
        badge="Disponibilidad"
        titulo-antes="Agenda del"
        titulo-destaque="especialista en Madrid"
        subtitulo="Las franjas se asignan por orden de solicitud. Una vez completada la agenda, la siguiente visita queda condicionada al calendario corporativo."
      />

      <div class="agenda-bloco">
        <div class="agenda-info">
          <div class="agenda-info-linha">
            <span class="agenda-info-label">Visita prevista</span>
            <strong class="agenda-info-valor">Próximas semanas en Madrid</strong>
          </div>
          <div class="agenda-info-linha">
            <span class="agenda-info-label">Duración por consulta</span>
            <strong class="agenda-info-valor">30 a 45 minutos</strong>
          </div>
          <div class="agenda-info-linha">
            <span class="agenda-info-label">Franjas por día</span>
            <strong class="agenda-info-valor">Limitadas a la agenda del especialista</strong>
          </div>
          <div class="agenda-info-linha">
            <span class="agenda-info-label">Asignación</span>
            <strong class="agenda-info-valor">Por orden de solicitud</strong>
          </div>
        </div>

        <!-- Mini-grid visual de status de agenda (dias da semana) -->
        <div class="agenda-status">
          <div class="agenda-status-titulo">Estado orientativo de las franjas</div>
          <div class="agenda-status-grid">
            <div v-for="(dia, i) in diasAgenda" :key="i" class="agenda-dia" :class="dia.status">
              <span class="agenda-dia-label">{{ dia.label }}</span>
              <span class="agenda-dia-status">{{ dia.statusTexto }}</span>
            </div>
          </div>
          <p class="agenda-status-aviso">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>
            Estado orientativo. La franja exacta se confirma tras la solicitud.
          </p>
        </div>

        <a href="#formulario-compra" @click.prevent="scrollToForm" class="agenda-cta">
          Reservar mi franja
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M5 12h14"/><path d="m12 5 7 7-7 7"/>
          </svg>
        </a>
      </div>
    </SecaoPadrao>

    <!-- ============================================================
         5. FAQ — quebra de objeções sobre a visita
         ============================================================ -->
    <SecaoPadrao variante="alt">
      <SecaoHeader badge="Preguntas frecuentes">
        <template #titulo>Lo que más nos preguntan sobre la visita</template>
      </SecaoHeader>

      <Faq :items="faqItems" />
    </SecaoPadrao>

    <!-- ============================================================
         6. FORMULÁRIO DE CAPTURA
            Mesmo FormularioLead, copy institucional adaptada.
         ============================================================ -->
    <SecaoPadrao id="formulario-compra" class="secao-formulario">
      <FormularioLead
        idioma="es"
        :active-campaign="acConfig"
        :redirect-to="{ name: 'madri-local-gracias' }"
        titulo-badge="Solicitar demostración"
        titulo-parte1="Reserve su franja para la"
        titulo-destaque="demostración en Madrid"
        subtitulo="Complete sus datos y nuestro equipo se pondrá en contacto por WhatsApp en menos de 24 h para confirmar fecha, hora y dirección de la consulta."
        texto-botao="Reservar mi franja"
        @submitted="onLeadSubmitted"
      />
    </SecaoPadrao>

    <!-- FOOTER -->
    <template #rodape>
      <RodapeSite
        marca="OligoCheck"
        texto="Análisis mineral intracelular en tiempo real. Tecnología profesional para consultas sanitarias."
        direitos="Todos los derechos reservados."
      />
    </template>
  </AppShell>
</template>

<script setup>
import { ref } from 'vue'
import AppShell from '@/components/global/layout/AppShell.vue'
import AlertaTopo from '@/components/global/layout/AlertaTopo.vue'
import PageHero from '@/components/global/layout/PageHero.vue'
import RodapeSite from '@/components/global/layout/RodapeSite.vue'
import SecaoPadrao from '@/components/global/secao/SecaoPadrao.vue'
import SecaoHeader from '@/components/global/secao/SecaoHeader.vue'
import BadgePill from '@/components/global/secao/BadgePill.vue'
import FeatureCard from '@/components/global/ui/FeatureCard.vue'
import TrustBar from '@/components/global/ui/TrustBar.vue'
import Faq from '@/components/global/ui/Faq.vue'
import FormularioLead from '@/components/global/formulario/FormularioLead.vue'
import logoBranco from '@/assets/images/logo-branco.svg'
import { sendLeadToWebhook } from '@/lib/webhookLead'

/* Idioma fixo ES — campanha exclusiva Madrid. */
const currentLang = ref('es')

/* ============================================================
   ActiveCampaign — form_43 (mesmo form da v1).
   Manter o mesmo form_id em ambas as versões permite totalizar
   leads de Madrid em uma única automation no AC. A origem (v1
   vs v2) pode ser distinguida pela URL de referência registrada
   no contato (ou criando um custom field "origem" no AC).
   ============================================================ */
const acConfig = {
  endpoint: 'https://eduardgasset95711.activehosted.com/proc.php',
  u: '43',
  f: '43',
  s: '',
  c: '0',
  m: '0',
  act: 'sub',
  v: '2',
  or: '25f5f87a-9bf1-4cb4-b419-7d187dd570fd'
}

/* WhatsApp comercial — ângulo "consultar disponibilidad",
   tom institucional, sem urgência exagerada. */
const whatsappComercial = '34609644237'
const whatsappComercialUrl =
  `https://api.whatsapp.com/send/?phone=${whatsappComercial}` +
  `&text=${encodeURIComponent('Hola, vi la página de la presentación exclusiva de OligoCheck en Madrid y me gustaría consultar la disponibilidad de franjas para una demostración en mi consulta.')}`

/* Status orientativo da agenda — reforça escassez visualmente.
   Os textos não usam datas duras (que ficariam desatualizadas);
   mostra apenas o nível de ocupação por dia da semana.

   status: 'cheio' | 'quase' | 'livre'
   Edite à medida que a agenda real for sendo preenchida. */
const diasAgenda = [
  { label: 'Lunes',    status: 'cheio',  statusTexto: 'Completa' },
  { label: 'Martes',   status: 'quase',  statusTexto: '1 franja' },
  { label: 'Miércoles',status: 'quase',  statusTexto: '2 franjas' },
  { label: 'Jueves',   status: 'livre',  statusTexto: 'Disponible' },
  { label: 'Viernes',  status: 'cheio',  statusTexto: 'Completa' }
]

/* ============================================================
   FAQ — quebra de objeções sobre a visita presencial.
   Foco em "sem custo / sem compromisso" (alivia barreira de
   profissional frio) + duração + o que precisa preparar.
   ============================================================ */
const faqItems = [
  {
    question: '¿La demostración tiene algún coste?',
    answer: 'No. La visita del especialista a su consulta es totalmente gratuita y sin compromiso de compra. Forma parte del proceso de presentación corporativa del equipo OligoCheck en Madrid.'
  },
  {
    question: '¿Cuánto dura la visita del especialista?',
    answer: 'Aproximadamente 30 a 45 minutos, dependiendo del nivel de profundidad técnica que su equipo profesional desee abordar. Incluye presentación, demostración en vivo y sesión de consultas.'
  },
  {
    question: '¿Qué necesito preparar en mi consulta para la demostración?',
    answer: 'Nada en especial. Basta con una sala con un punto eléctrico y un ordenador o tablet disponibles. El especialista lleva el equipo, el material de demostración y los informes de muestra.'
  },
  {
    question: '¿Puede asistir mi equipo profesional?',
    answer: 'Sí. La demostración está pensada para integrarse a su entorno real de trabajo, así que es bienvenido que asistan los profesionales de su consulta que potencialmente operarían el equipo (médicos, nutricionistas, técnicos auxiliares).'
  },
  {
    question: '¿Qué pasa después de la demostración? ¿Hay alguna obligación?',
    answer: 'Ninguna. Tras la demostración, recibe una propuesta personalizada por escrito (sin presión ni urgencia comercial). Si decide avanzar, el equipo coordina la entrega; si no, la solicitud se cierra simplemente.'
  },
  {
    question: '¿Por qué la agenda está limitada en Madrid?',
    answer: 'El especialista realiza visitas presenciales en consultas concretas durante una ventana definida en el calendario corporativo. Una vez completadas las franjas de esta ventana, la siguiente visita queda condicionada a la próxima asignación de agenda.'
  }
]

const scrollToForm = () => {
  const el = document.getElementById('formulario-compra')
  if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' })
}

/* ============================================================
   Conversão → webhook Make (responsável por chamar a CAPI).
   `content_name` distinto da v1 para separar relatórios.
   ============================================================ */
const onLeadSubmitted = (payload) => {
  sendLeadToWebhook(payload, {
    contentName: 'madri_local_demo_v2',
    contentCategory: 'demostracion_madrid',
    currency: 'EUR'
  })
}
</script>

<style scoped>
/* ============================================
   TÍTULO CUSTOMIZADO (sem ângulo de rebranding)
   ============================================ */
.titulo-pre {
  font-family: var(--ds-font-display);
}

/* ============================================
   CAMINHOS (2 CTAs dentro do hero)
   — replicado da OligoscanLanding para manter consistência
   ============================================ */
.caminhos-pergunta {
  font-family: var(--ds-font-bold);
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 2px;
  color: var(--ds-text-dim);
  margin: 0 0 var(--ds-s-5);
}

.caminhos-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--ds-s-4);
  margin-bottom: var(--ds-s-7);
}

.caminho-card {
  display: flex;
  align-items: center;
  gap: var(--ds-s-4);
  text-align: left;
  background: var(--ds-surface-2);
  border: 1px solid var(--ds-border);
  border-radius: var(--ds-r-lg);
  padding: 22px;
  text-decoration: none;
  color: var(--ds-text);
  transition: all var(--ds-t-smooth);
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.caminho-card::before {
  content: '';
  position: absolute;
  inset: 0;
  opacity: 0;
  transition: opacity var(--ds-t-base);
}

.caminho-compra::before {
  background: linear-gradient(135deg, rgba(245, 130, 32, 0.12), transparent 60%);
}

.caminho-suporte::before {
  background: linear-gradient(135deg, rgba(37, 211, 102, 0.12), transparent 60%);
}

.caminho-card:hover::before { opacity: 1; }

.caminho-card:hover {
  transform: translateY(-3px);
  box-shadow: var(--ds-shadow-lg);
}

.caminho-compra:hover { border-color: rgba(245, 130, 32, 0.45); }
.caminho-suporte:hover { border-color: rgba(37, 211, 102, 0.45); }

.caminho-icone {
  min-width: 56px;
  height: 56px;
  border-radius: var(--ds-r-md);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1;
  flex-shrink: 0;
}

.caminho-compra .caminho-icone {
  background: var(--ds-gradient-warning);
  color: #fff;
  box-shadow: var(--ds-shadow-glow-warning);
}

.suporte-icone {
  background: var(--ds-gradient-success);
  color: #fff;
  box-shadow: var(--ds-shadow-glow-success);
}

.caminho-conteudo {
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 2px;
  position: relative;
  z-index: 1;
}

.caminho-label {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  color: var(--ds-text-dim);
  font-family: var(--ds-font-bold);
}

.caminho-titulo {
  font-family: var(--ds-font-bold);
  font-size: 18px;
  color: var(--ds-text);
  line-height: 1.2;
}

.caminho-desc {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.6);
  line-height: 1.4;
  margin-top: 2px;
}

.caminho-seta {
  color: var(--ds-text-faint);
  transition: all var(--ds-t-base);
  position: relative;
  z-index: 1;
  flex-shrink: 0;
}

.caminho-card:hover .caminho-seta {
  color: var(--ds-text);
  transform: translateX(4px);
}

/* ============================================
   SEÇÃO EXPLICATIVA (¿Por qué esta visita?)
   ============================================ */
.explicativa-grid {
  display: grid;
  grid-template-columns: 1.1fr 1fr;
  gap: 60px;
  align-items: center;
}

.explicativa-desc {
  font-size: 16px;
  color: var(--ds-text-muted);
  line-height: 1.6;
  margin: var(--ds-s-5) 0 var(--ds-s-7);
}

.antes-depois {
  display: flex;
  align-items: center;
  gap: var(--ds-s-4);
  margin-bottom: var(--ds-s-7);
  padding: var(--ds-s-5);
  background: var(--ds-surface-1);
  border: 1px solid var(--ds-border-subtle);
  border-radius: var(--ds-r-md);
}

.ad-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.ad-label {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  color: rgba(255, 255, 255, 0.4);
  font-family: var(--ds-font-bold);
}

.ad-item strong {
  font-family: var(--ds-font-display);
  font-size: 22px;
  color: var(--ds-text);
}

.ad-antes strong {
  color: var(--ds-text-dim);
}

.ad-seta {
  color: var(--ds-accent);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.explicativa-lista {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.explicativa-lista li {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  font-size: 15px;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.5;
}

.explicativa-lista li svg {
  color: var(--ds-ciano);
  background: rgba(26, 175, 149, 0.15);
  border-radius: 50%;
  padding: 3px;
  margin-top: 1px;
  flex-shrink: 0;
  box-sizing: content-box;
}

.explicativa-visual {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 380px;
}

.visual-glow {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 110%;
  height: 90%;
  background: radial-gradient(circle, rgba(20, 203, 240, 0.2) 0%, transparent 70%);
  z-index: 0;
  animation: pulseGlow 5s ease-in-out infinite;
}

@keyframes pulseGlow {
  0%, 100% { opacity: 0.5; transform: translate(-50%, -50%) scale(0.95); }
  50% { opacity: 0.8; transform: translate(-50%, -50%) scale(1.05); }
}

.visual-img {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 440px;
  height: auto;
  filter: drop-shadow(0 20px 50px rgba(0, 0, 0, 0.4));
  animation: float 6s ease-in-out infinite;
}

@keyframes float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-12px); }
}

/* ============================================
   FEATURES (grid wrapper)
   ============================================ */
.features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: var(--ds-s-5);
}

/* ============================================
   TECH BOX (ESPECTROFOTOMETRIA) — clone da OligoscanLanding
   ============================================ */
.tech-box {
  margin-top: var(--ds-s-8);
  background:
    linear-gradient(135deg, rgba(20, 203, 240, 0.06) 0%, rgba(26, 175, 149, 0.04) 100%),
    rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(20, 203, 240, 0.2);
  border-radius: var(--ds-r-xl);
  padding: 36px;
  position: relative;
  overflow: hidden;
}

.tech-box::before {
  content: '';
  position: absolute;
  top: -60px;
  right: -60px;
  width: 220px;
  height: 220px;
  background: radial-gradient(circle, rgba(20, 203, 240, 0.15) 0%, transparent 70%);
  pointer-events: none;
}

.tech-box-grid {
  display: grid;
  grid-template-columns: 60px 1fr;
  gap: 24px;
  position: relative;
  z-index: 1;
}

.tech-box-icone {
  width: 56px;
  height: 56px;
  border-radius: var(--ds-r-md);
  background: linear-gradient(135deg, rgba(20, 203, 240, 0.2), rgba(20, 203, 240, 0.08));
  border: 1px solid rgba(20, 203, 240, 0.3);
  color: var(--ds-accent);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-shadow: var(--ds-shadow-glow-azul);
}

.tech-box-label {
  font-family: var(--ds-font-bold);
  font-size: 11px;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: var(--ds-ciano);
  margin-bottom: 6px;
}

.tech-box-titulo {
  font-family: var(--ds-font-display);
  font-size: 22px;
  color: var(--ds-text);
  margin: 0 0 12px;
  line-height: 1.3;
  letter-spacing: -0.3px;
}

.tech-box-desc {
  font-size: 15px;
  color: rgba(255, 255, 255, 0.75);
  line-height: 1.6;
  margin: 0 0 22px;
}

.tech-box-lista {
  list-style: none;
  padding: 0;
  margin: 0 0 20px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  counter-reset: tech-steps;
}

.tech-box-lista li {
  display: flex;
  gap: 14px;
  padding: 14px 16px;
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  align-items: flex-start;
  counter-increment: tech-steps;
  position: relative;
}

.tech-box-lista li::before {
  content: counter(tech-steps);
  width: 28px;
  height: 28px;
  border-radius: var(--ds-r-sm);
  background: var(--ds-accent-soft);
  color: var(--ds-accent);
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: var(--ds-font-bold);
  font-size: 13px;
  border: 1px solid var(--ds-accent-border);
  flex-shrink: 0;
  margin-top: 1px;
}

.tech-step-body {
  flex: 1;
  min-width: 0;
}

.tech-box-lista li strong {
  display: block;
  font-family: var(--ds-font-bold);
  font-size: 14px;
  color: var(--ds-text);
  margin-bottom: 4px;
  line-height: 1.35;
}

.tech-box-lista li span {
  display: block;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.68);
  line-height: 1.55;
}

.tech-box-nota {
  display: inline-flex;
  align-items: center;
  gap: var(--ds-s-2);
  font-size: 12px;
  color: var(--ds-text-dim);
  margin: 0;
  padding-top: 14px;
  border-top: 1px solid var(--ds-border-subtle);
  font-style: italic;
}

.tech-box-nota svg {
  color: var(--ds-ciano);
  flex-shrink: 0;
}

@media (max-width: 720px) {
  .tech-box { padding: 26px 20px; border-radius: var(--ds-r-lg); }
  .tech-box-grid { grid-template-columns: 1fr; gap: var(--ds-s-4); }
  .tech-box-icone { width: 48px; height: 48px; }
  .tech-box-titulo { font-size: 19px; }
  .tech-box-desc { font-size: 14px; }
}

/* ============================================
   AGENDA / ESCASEZ — bloco dedicado
   ============================================ */
.agenda-bloco {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--ds-s-7);
  align-items: stretch;
  background: var(--ds-surface-1);
  border: 1px solid var(--ds-accent-border);
  border-radius: var(--ds-r-xl);
  padding: var(--ds-s-7);
  position: relative;
}

.agenda-info {
  display: flex;
  flex-direction: column;
  gap: var(--ds-s-4);
}

.agenda-info-linha {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding-bottom: var(--ds-s-4);
  border-bottom: 1px solid var(--ds-border-subtle);
}

.agenda-info-linha:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.agenda-info-label {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  color: var(--ds-text-dim);
  font-family: var(--ds-font-bold);
}

.agenda-info-valor {
  font-family: var(--ds-font-display);
  font-size: 17px;
  color: var(--ds-text);
  letter-spacing: -0.2px;
}

.agenda-status {
  display: flex;
  flex-direction: column;
  gap: var(--ds-s-3);
}

.agenda-status-titulo {
  font-family: var(--ds-font-bold);
  font-size: 12px;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: var(--ds-text-dim);
}

.agenda-status-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: var(--ds-s-2);
}

.agenda-dia {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 12px 6px;
  border-radius: var(--ds-r-sm);
  border: 1px solid var(--ds-border-subtle);
  background: var(--ds-surface-2);
  text-align: center;
}

.agenda-dia-label {
  font-family: var(--ds-font-bold);
  font-size: 12px;
  color: var(--ds-text);
  letter-spacing: 0.3px;
}

.agenda-dia-status {
  font-size: 10px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  font-family: var(--ds-font-bold);
}

.agenda-dia.cheio {
  background: rgba(255, 77, 121, 0.06);
  border-color: rgba(255, 77, 121, 0.25);
}
.agenda-dia.cheio .agenda-dia-status { color: #ff7a9a; }
.agenda-dia.cheio .agenda-dia-label  { color: var(--ds-text-dim); }

.agenda-dia.quase {
  background: var(--ds-warning-soft);
  border-color: rgba(245, 130, 32, 0.3);
}
.agenda-dia.quase .agenda-dia-status { color: var(--ds-warning-light); }

.agenda-dia.livre {
  background: var(--ds-success-soft);
  border-color: rgba(37, 211, 102, 0.3);
}
.agenda-dia.livre .agenda-dia-status { color: var(--ds-success); }

.agenda-status-aviso {
  display: inline-flex;
  align-items: center;
  gap: var(--ds-s-2);
  font-size: 12px;
  color: var(--ds-text-dim);
  margin: 0;
  font-style: italic;
}

.agenda-status-aviso svg {
  color: var(--ds-ciano);
  flex-shrink: 0;
}

.agenda-cta {
  grid-column: 1 / -1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--ds-s-2);
  padding: 16px 28px;
  border-radius: var(--ds-r-full);
  background: var(--ds-gradient-warning);
  color: var(--ds-text);
  font-family: var(--ds-font-bold);
  font-size: 15px;
  text-decoration: none;
  box-shadow: var(--ds-shadow-glow-warning);
  transition: transform var(--ds-t-base), box-shadow var(--ds-t-base);
  margin-top: var(--ds-s-3);
}

.agenda-cta:hover {
  transform: translateY(-2px);
  box-shadow: 0 14px 28px -6px rgba(245, 130, 32, 0.55);
}

/* ============================================
   FORMULÁRIO — glow laranja de fundo (clone OligoscanLanding)
   ============================================ */
.secao-formulario::before {
  content: '';
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 600px;
  height: 300px;
  background: radial-gradient(circle, rgba(245, 130, 32, 0.08) 0%, transparent 70%);
  pointer-events: none;
}

.secao-formulario :deep(.ds-container) {
  position: relative;
  z-index: 1;
}

/* ============================================
   RESPONSIVO ESPECÍFICO DA PÁGINA
   ============================================ */
@media (max-width: 900px) {
  .caminhos-grid { grid-template-columns: 1fr; gap: var(--ds-s-3); }
  .caminho-card { padding: 18px; }

  .explicativa-grid { grid-template-columns: 1fr; gap: var(--ds-s-8); }
  .explicativa-visual { min-height: auto; order: -1; }
  .visual-img { max-width: 320px; }

  .agenda-bloco {
    grid-template-columns: 1fr;
    gap: var(--ds-s-5);
    padding: var(--ds-s-5);
  }
}

@media (max-width: 480px) {
  .antes-depois { flex-direction: column; gap: var(--ds-s-3); text-align: center; }
  .ad-seta { transform: rotate(90deg); }

  .agenda-status-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .agenda-info-valor { font-size: 15px; }
}
</style>
